module.exports = [{
      plugin: require('/tmp/264a9f21/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
